module.exports = __webpack_public_path__ + "static/media/galerija_2013 (8).fefc903a.jpg";